import { styled } from "styled-components"

const Container = styled.div`
    margin: 0 auto;
    height: 100%;

    display: grid;
    grid-template-columns: 1fr ${({ middleWidth }) => middleWidth} 1fr;

    position: relative;
    
    @media screen and (max-width: 1250px) {
        grid-template-columns: 1fr ${({ middleWidth }) => middleWidth};
    }

    &::before {
        content: '';
        width: 20px;
        height: 350px;
        top: 100%;
        position: absolute;
        background-color: ${({ theme }) => theme.colors.primary};
        left: 50%;
        transform: translateX(-50%);
        
        @media screen and (max-width: 1250px) {
            left: 100%;
            transform: translateX(-100%);
        }
    }
`;

const Left = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    @media screen and (min-width: 1250px) {
        & > div:nth-child(even) {
            left: calc(100% + ${({ middleWidth }) => middleWidth});
            margin-left: ${({ gap }) => gap};
            margin-right: auto;
        }
    
        & > div:nth-child(even) > span {
            left: calc(${({ gap }) => gap} * -1 - ${({ middleWidth }) => middleWidth} / 2);
            transform: translateY(-50%) translateX(-50%);
        }
    }

`;

const Card = styled.div`
    /* background-color: rgb(255, 166, 255); */
    width: fit-content;
    margin-left: auto;
    margin-right: ${({ gap }) => gap};

    position: relative;
`;

const Middle = styled.div`
    width: ${({ middleWidth }) => middleWidth};
    height: 100%;
    margin: 0 auto;
    background: linear-gradient(to top, ${({ theme }) => theme.colors.primary}, #fa7f72);
    border-radius: 10px 10px 0 0;
`;

const Mark = styled.span`
    position: absolute;
    background-color: white;
    width: 15px;
    height: 15px;

    clip-path: circle();

    top: 50%;

    right: calc((${({ gap }) => gap} * -1) - ${({ middleWidth }) => middleWidth} / 2);

    transform: translateY(-50%) translateX(50%);

    @media screen and (max-widht: 1250px) {
        
    }
`;

export function Timeline({ gap, middleWidth, children }) {
    return (
        <Container middleWidth={middleWidth}>
            <Left gap={gap} middleWidth={middleWidth}>
                {children?.map(el => (
                    <Card gap={gap}>
                        {el}
                        <Mark gap={gap} middleWidth={middleWidth}></Mark>
                    </Card>
                ))}
            </Left>
            <Middle middleWidth={middleWidth} />
        </Container>
    )
}